/* eslint-disable */

import Swiper from 'swiper';
// import SwiperCore, { Navigation, Pagination } from 'swiper/core';
// SwiperCore.use([Navigation, Pagination]);
// import Swiper from 'swiper/bundle';



$('.specialOffersSwipper').each(function () {
	//add class stopAutoPlay to stop autoplay
	var mySwiper = new Swiper($(this), {
		// Optional parameters
		direction: 'horizontal',
		loop: false,
		lazy: true,
		// freeMode: true,
		// If we need pagination
		slidesPerView: 5,
		spaceBetween: 20,
		centeredSlides: false,
		speed: 1350,
		loop: true,

		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
		pagination: {
			el: $(this).parent(".specialOffers").find('.swiper-pagination'),
			clickable: true,
		},
		breakpoints: {
			580: {
				slidesPerView: 'auto',
				spaceBetween: 10,


			},
			// when window width is >= 480px
			768: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 10
			},
			1450: {
				slidesPerView: 4,
				spaceBetween: 20
			}
		},
		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// And if we need scrollbar
		// scrollbar: {
		// 	el: '.swiper-scrollbar',
		// },
	});
	if ($(this).hasClass('stopAutoPlay')) {
		mySwiper.autoplay.stop();
	} else {
		$(this).on('mouseenter', function (e) {
			console.log('stop autoplay');
			mySwiper.autoplay.stop();
		})
		$(this).on('mouseleave', function (e) {
			console.log('start autoplay');
			mySwiper.autoplay.start();
		})
	}
})



// const swiper2 = new Swiper(".topPicks", {
// 	// Optional parameters
// 	direction: 'horizontal',
// 	effect: "fade",
// 	loop: true,
// 	lazy: true,
// 	// If we need pagination
// 	slidesPerView: 1,
// 	pagination: {
// 		el: ".homeWidget-1 .swiper-pagination",
// 		clickable: true,
// 	},
// 	autoplay: {
// 		delay: 2500,
// 		disableOnInteraction: false,
// 	}
// });


//
if ($('.gallery-top').length > 0) {
	var galleryTop = new Swiper('.gallery-top', {
		effect: "fade",
		// loop: true,
		lazy: true,
		// If we need pagination
		slidesPerView: 1,
		speed: 1000,

		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: ".gallery-top .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			580: {
				speed: 600,

				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},

			},
		}
	});
	var galleryThumbs = new Swiper('.gallery-bottom', {
		effect: "fade",
		// loop: true,
		lazy: true,
		// If we need pagination
		slidesPerView: 1,



	});
	galleryTop.controller.control = galleryThumbs;
	galleryThumbs.controller.control = galleryTop;
}
//

$('.heroBannerSwiper').each(function () {
	var loop = false;
	if ($(this).find('.swiper-slide').not('.swiper-slide-duplicate').length > 1) {
		loop = true;

	}
	var heroBannerSwiper = new Swiper($(this), {
		// Optional parameters
		// direction: 'horizontal',
		loop: loop,
		effect: "fade",
		// If we need pagination
		slidesPerView: 1,
		spaceBetween: 0,
		pagination: {
			el: $(this).parent().parent(".heroBanner").find('.swiper-pagination'),
			clickable: true,
		},
		speed: 1600,

		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		breakpoints: {
			580: {
				speed: 1000,

				autoplay: {
					delay: 3500,
					disableOnInteraction: false,
				},

			},
		}
		// Navigation arrows
		// navigation: {
		// 	nextEl: '.swiper-button-next',
		// 	prevEl: '.swiper-button-prev',
		// },

		// And if we need scrollbar

	});
	heroBannerSwiper.on('slideChange', function () {});



	function initVideo() {
		if (($('.heroBannerSwiper .swiper-slide')).not('.swiper-slide-duplicate').length > 1) {

			var v = document.getElementsByClassName('heroBannerSwiper')[0].getElementsByClassName('swiper-slide-active')[0].getElementsByTagName("video")[0];
			//alert('op');
			if (v) {
				v.addEventListener("canplay", function () {
					console.log(' video started');
					heroBannerSwiper.autoplay.stop();

				}, true);

				v.addEventListener("ended", function () {
					console.log(' video ended');
					heroBannerSwiper.slideNext();
					heroBannerSwiper.autoplay.start();


				}, true);
			}
		}

	}
	heroBannerSwiper.on('transitionStart', function (swiper) {

		var swiperSlideActive = $('.heroBannerSwiper .swiper-slide-active');
		if ($(swiperSlideActive).find('.thevideo').length > 0) {
			heroBannerSwiper.autoplay.stop();
			$(swiperSlideActive).addClass('swiperSlideActive');

			var v = document.getElementsByClassName('heroBannerSwiper')[0].getElementsByClassName('swiper-slide-active')[0].getElementsByTagName("video")[0];
			v.currentTime = 0;

			v.play();

			initVideo();
		}

		// console.log(swiperSlideActive);
	});
	initVideo();



})
if ($('.barAlerts').length > 0) {
	$('body').addClass('hasBarAlert');
	if ($('.barAlerts .swiper-container').length > 0) {
		let loop = false;
		if ($('.barAlerts .swiper-container .swiper-slide').length > 1) {
			loop = true;

		}
		var barAlertswiper = new Swiper('.barAlerts .swiper-container', {

			direction: 'vertical',
			mousewheelControl: true,
			slidesPerView: 1,
			autoplay: true,
			loop: loop,
			speed: 1000,
			noSwiping: false,
			// allowSlideNext: false,
			// allowSlidePrev: false,
			allowTouchMove: false,

		});
	}

	if (($('.barAlerts .close-alert-bar').length) > 0) {
		let el = $('.barAlerts');

		if (sessionStorage.getItem('HideTopBar') !== null) {

			el.remove();
			$('body').removeClass('hasBarAlert');

		}
		$(".barAlerts").delegate(".close-alert-bar", "click", function () {
			let $target = $(".barAlerts");
			$target.hide('30', function () {
				sessionStorage.setItem('HideTopBar', 'true');

				if (HideTopBarEvent) {
					HideTopBarEvent();
				}

				$target.remove();
				$('body').removeClass('hasBarAlert');

			});


		})


	}


}






//gallerySlider



$('.gallerySlider').each(function () {
	var loop = false;
	let dynamicBullets = false

		if ($(this).hasClass('has-dynamic-bullets')) {
			dynamicBullets = true
		}
		
	if ($(this).find('.swiper-slide').not('.swiper-slide-duplicate').length > 1) {
		loop = true;

	}
	var gallerySlider = new Swiper($(this), {
	
		loop: loop,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 0,
		pagination: {
			el: $(this).parent().find('.swiper-pagination'),
			clickable: true,
			dynamicBullets: dynamicBullets,
			dynamicMainBullets: 7,
		},
		speed: 1600,

		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	})





})



//galleryPopup

/* eslint-disable */

// Photo Gallery

let clicked_before = false;
let MSwiper;
window.pushUrlState = function (url) {
	window.history.pushState({
		path: url
	}, '', url);
}

function CloseGallery() {
	$('.photoGalleryModal').modal('hide');

}


function loadmedia(url, index = 0) {
	//$('.photoGalleryModal').find('.in-details').html('');
	$('.photoGalleryModal').find('.gallery').html('');

	$.getJSON(url, function (data) {
		var mylist = "",
			myTitle = "";

		if (typeof data === 'object') {


			var inDetails = ` 
							  <div class = "text mb-3" >${ data.media['desc']} </div>`


			$.each(data.media['gallery'], function (key, media) {
				mylist += ` <div class="swiper-slide"> <div class='swiper-zoom-container'><img class = "img  img-fluid mx-auto" src = ${  media.url } > </div> </div>`;


			});



			setTimeout(function () {

				// $(thisGalleryWrapp).html('');
				$('.photoGalleryModal').find('.in-details').html('');
				$('.photoGalleryModal').find('.gallery').html('');


				let data_output = `<div class="gallery has-dynamic-bullets swiper-container">
				                         <div class=" swiper-wrapper align-items-center"></div>
									     <div class = "swiper-pagination     "> </div>
									</div>`

				// $('.photoGalleryModal').find('.slider-data').html('<div class="gallery has-dynamic-bullets swiper-container"><div class=" swiper-wrapper align-items-center"></div><div class="swiper-pagination position-relative mt-4"></div></div>' + '<div class="title-photo-gallery">ddd dd</div>');
				$('.photoGalleryModal').find('.theGallery').html(data_output);

				$('.photoGalleryModal').find('.gallery .swiper-wrapper').html(mylist);
				$('.photoGalleryModal').find('.gallery .swiper-wrapper').html(mylist);
				
				$('.photoGalleryModal').find('.in-details').html(inDetails);

				$('.photoGalleryModal').removeClass('wait-load');


				//

				var thisSlider = $('.photoGalleryModal').find('.gallery');
				let dynamicBullets = false

				if (thisSlider.hasClass('has-dynamic-bullets')) {
					dynamicBullets = true
				}
				MSwiper = new Swiper(thisSlider, {

					spaceBetween: 0,
					loop: false,
					slidesPerView: 1,
					effect: 'fade',
					speed: 1000,
					preloadImages: false,

					lazy: {
						loadPrevNext: true,
					},

					// zoom: {
					// 	maxRatio: 3,
					// 	minRatio: 1
					//   },
					
					  on: {
						slideChangeTransitionEnd: function () {
						  console.log('clicked!')
						//  this.zoom.out();
						}
					  },

					pagination: {
						el: $('.photoGalleryModal').find('.swiper-pagination'),
						clickable: true,
						dynamicBullets: dynamicBullets,
						dynamicMainBullets: 7,

					},


					navigation: {
						nextEl: $('.photoGalleryModal').find('.swiper-button-next'),
						prevEl: $('.photoGalleryModal').find('.swiper-button-prev'),
					},






				});














			}, 200);

		}
	});
};







if ($('.has-events-data').length) {




		$('.has-events-data').click(function () {
			let ActiveGallery = $(this);


			let DataUrl = $(this).data('url');
			let index = parseInt(0);
			if ($(this).attr('index')) {
				index = parseInt($(this).attr('index'));

			}

			$('.photoGalleryModal').modal('show');
			if ($(this).data('id') && !$(this).hasClass('stopPushState')) {
				let id = $(this).data('id');
				//	if (history.pushState) {
				window.pushUrlState('?' + modalItem + "=" + id)


				//}
			}

			$('.photoGalleryModal').find('.slider-data').html('');
			loadmedia(DataUrl, index);
			$('.photoGalleryModal').addClass('wait-load');
			clicked_before = true;









		});

}


//for opening Modal
let url = '';
let furl = window.location.href;

function GetURLParameter(sParam) {

	var sPageURL = window.location.search.substring(1);

	var sURLVariables = sPageURL.split('&');

	for (var i = 0; i < sURLVariables.length; i++) {

		var sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] == sParam) {

			return sParameterName[1];

		}

	}

}

$('.photoGalleryModal').on('hide.bs.modal', function () {
	if ((history.pushState)) {

		url = "?";

		window.pushUrlState('?')


	}
})
if (typeof modalItem !== 'undefined' && (furl.indexOf('?' + modalItem + '=') != -1)) {
	let active_Item = (GetURLParameter(modalItem));
	if ((active_Item) && ($('*[data-id=' + active_Item + ']').length)) {
		$('*[data-id=' + active_Item + ']').click();

		var n = $('*[data-id=' + active_Item + ']');
		//	n.addClass('active')
		$("html,body").animate({
			scrollTop: n.offset().top + 50
		}, 500);

	}


}


//end modal
